import type { ChartConfig } from './types';

export const chartConfig: ChartConfig = {
  margin: { 
    top: 10, 
    right: 10, 
    left: 10, 
    bottom: 20 
  },
  barSize: 50,
  cornerRadius: 4,
};